<template>
<nav>

  <div class="drawer" :class="{'active':drawer}">
    <template v-for="(menubot, indexUl) in data.menubots">
      <template v-if="conteoPags >= calculateNumberOfPages(indexUl)">
        <div class="menu-tile" :key="'item'+indexUl">
          <div class="menu-tile-button"><button @click="unroll(menubot), drawer = !drawer">{{menubot.short}}</button></div>
          <div v-if="drawer" class="menu-tile-text hidden-xs-only"><router-link :to="menubot.link" @click.native.prevent="clickNav, hideNav(indexUl)">{{menubot.name}}</router-link></div>
          <v-layout wrap v-if="drawer && menubot.unroll" class="submenu hidden-xs-only">
            <div class="submenu-tile flex" v-for="submenubot in menubot.subt" :key="submenubot.link">
              <template v-if="(submenubot.pages[0] + calculateNumberOfPages(indexUl)) <= conteoPags">
                <div class="submenu-tile-button">
                  <div class="submenu-tile-indicator">
                    .
                  </div>
                </div>
                <div v-if="drawer" class="submenu-tile-text flex hidden-xs-only"><router-link :to="submenubot.link">{{submenubot.name}}</router-link></div>
              </template>
            </div>
          </v-layout>
        </div>
      </template>
    </template>
  </div>
  <!-- Inicio menú teléfonos y tablets -->
  <div v-if="drawer" class="menu_paths">
    <div v-for="(menubot, indexUl) in data.menubots" class="menu-tile-text wrap hidden-sm-and-up" :key="'menuitem'+indexUl">
      <template v-if="conteoPags >= calculateNumberOfPages(indexUl)">
        <v-layout>
          <v-flex>
            <router-link :to="menubot.link">{{menubot.name}}</router-link>
          </v-flex>
        </v-layout>
        <v-layout wrap v-if="drawer && menubot.unroll" class="submenu">
            <div class="submenu-tile flex" v-for="submenubot in menubot.subt" :key="submenubot.link">
              <template v-if="(submenubot.pages[0] + calculateNumberOfPages(indexUl)) <= conteoPags">
                <div class="submenu-tile-button">
                  <div>
                    .
                  </div>
                </div>
                <div v-if="drawer" class="submenu-tile-text flex"><router-link :to="submenubot.link">{{submenubot.name}}</router-link></div>
              </template>
            </div>
          </v-layout>
      </template>
    </div>
  </div>
  <!-- Fin menú teléfonos y tablets -->
</nav>
</template>
<script>
import scormmixins from '../js/mixins/scormmixins'

export default {
  mixins: [scormmixins],
  data() {
    return {
      data: '',
      drawer: false,
      items: [
        { title: 'Home', icon: 'dashboard' },
        { title: 'About', icon: 'question_answer' }
      ],
      mini: true,
      right: null
    }
  },
  created() {
    var self = this
    this.data = require('../assets/navegacion.json');
  },
  methods: {
    unroll (menubot) {
      this.data.menubots.forEach(el => {el.unroll = false})
      menubot.unroll = true
    },
    hey(modNum) {
      var canTemas = 0
      for(var i = 0; i < modNum; i++) {
        canTemas += this.data.menubots[i].canTemas
      }
      return canTemas
    },

    clickNav() {
      var routeArr = this.$route.path.split("/");
      var modName = routeArr[routeArr.length - 2];
      var pageNum = routeArr[routeArr.length - 1];

      this.data.menubots.forEach(function(element) {
        var botName = element.link.split("/");
        // Actualiza nombre en el encabezado
        console.log(botName)
        console.log(modName)
        console.log(pageNum)
        if(botName[1] == modName){
          this.$store.commit('temaName', element.name)
        }
        // Muestra los temas que se han visitado y oculta los temas futuros
        if (element.link === this.$route.path) {
          } else if (modName === botName[1]) {          
            // this.$store.commit('temaName', element.name)
          element.active = true;
        } else {
          element.active = false;
        }

        // Muestra los subtemas
        element.subt.forEach(function(subElem) {
          var subLink = subElem.link.split("/")
          if (subLink[1] === modName && (pageNum >= subElem.pages[0] && pageNum <= subElem.pages[1])) {
            this.$store.commit('subTemaName', subElem.name)
            this.$store.commit('temaName', element.name)
            subElem.active = true;
          } else {
            subElem.active = false;
          }
        }, this)
      }, this);
    },
    hideNav(event) {
      if (this.data.menubots[event].subt.length === 0) {
        this.navshow = false;
      }
    },
    calculateNumberOfPages(modNum) {
      return this.$store.getters.globalPage(modNum+1)
    },
    goTo(route){
      this.$router.push(route)
    }
  },
  watch: {
    '$route' (to, from) {
      this.clickNav();
    }
  },
  mounted() {
    this.clickNav();
  },
}
</script>


<style lang="scss" scoped>
@import '../sass/globals';
.drawer {
  position: absolute;
  z-index: 7;
  display: flex;
  flex-wrap: wrap;
  background-color: transparent;
  color: black;
  width: 46px;
  max-width: 100vw;
  &.active {
    width: 400px;
  }
  a {
    color: black;
    text-decoration: none;
  }
}

.menu-tile {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  &:nth-child(1) {
    .menu-tile-button{
      background-color: #7F4E21;
      border-top: 2px solid white;
    }
  }
  &:nth-child(2) .menu-tile-button{
      background-color: #FFBD48;
  }
  &:nth-child(3) .menu-tile-button{
      background-color: #EEFDFF;
  }
  &:nth-last-child(1) {
    .menu-tile-button{
      background-color: #121A26;
      border-bottom: 2px solid white;
    }
  }
}

.submenu {
  flex-basis: 100%;
}
.submenu-tile {
  width: 100%;
  flex-basis: 100%;
  flex-wrap: nowrap;
  display: flex;
  .submenu-tile-button {
    background: white;
    width: 3.3em;
    flex-basis: 3.3em;
    text-align: center;
    border-right: 1px solid gray;
  } 
  .submenu-tile-text {
    background: #eee;
    margin-right: 2px;
    border-bottom: 1px solid gray;
    min-height: 3rem;
    padding: 10px;
    max-width: calc(100% - 3.4rem);
    a {
      text-decoration: underline;
      &:hover {
        color: $verde-eco;
      }
    }
  } 
} 

.menu-tile-button{
  font-family: HelveticaNeueCn;
  font-weight: bold !important;
  border-left: 2px solid white;
  border-right: 2px solid white;
  button{
    border: 2px solid white;
    z-index: 1;
    background-color: #004535;
    border-radius: 100%;
    margin: 5px;
    font-size: 1.3em;
    display: block;
    min-width: 2em;
    min-height: 2em;
    max-width: 2em;
    max-height: 2em;
    text-align: center;
    color: white;
    @media (max-width: 600px) {
      margin: auto;
    }
  }
  @media (max-width: 600px) {
    width: 100%;
    border: 2px solid white;
  }
}
  .menu-tile-text {
    width: calc(300px - 2em);
    background-color: white;
    padding: 5px 10px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid gray;
    flex-basis: calc(100% - 3.5em);
  }

// .submenu-tile {
//   margin: 5px;
//   background-color: lighten($color: $yellow, $amount: 30%);
//   &:hover {
//     background-color: lighten($color: $yellow, $amount: 20%) 
//   }
// }

// Esta es la barra vertical
.drawer-btn{
  top: 0;
  position: absolute;
  width: 45px;
  height: 100%;
  background-color: $darkblue;
  z-index: 7;
  @media (max-width: 600px) {
      top: initial;
      bottom: 0;
      height: auto;
      width: 100%;
  }
}


@media (max-width: 600px) {
  nav {
    position: relative;
  }
  .drawer {
    position: relative;
    flex-flow: row;
    width: 100vw;
  }
  .menu_paths {
    position: absolute;
    min-height: 2rem;
    z-index: 20;
    top: 2.5rem;
  }
  .menu-tile-text {
    width: 100vw;
  }
}

.title {
  background: $darkblue;
  .nav-title{
    color: white !important;
  }
}
</style>
